module.exports = __webpack_public_path__ + "img/logo-nutas-mark.f49e5b64.png";